/*@ngInject*/
const FormEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, localization,
                                             configurationMediator, formViewerConstant, uIFormTemplateAction,
                                             configurationActionsUtil, modalUtil, coreConstant, formViewerModel,
                                             loadingBarHandler, uiFormTemplateModel, coreMediator) {

    $element.addClass('formEditorHeader');

    localization.getTranslations().then(function (translations) {
        this.formTemplateConfig = null;
        this.formTemplate = null;
        this.uiFormTemplateId = $stateParams.uiFormTemplateId;
        this.formTemplateUniqueName = '';

        this.hasEffectiveDate = false;
        this.formTemplateTypeLabel = null;
        this.enableSaveAndDiscard = false;

        this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');

        this.actions = [];
        this.actionSubTexts = {};
        this.context = {
            identifier: 'formEditor',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        this.context.actions[coreConstant.CONTEXT_NONE] = '';

        this.loadActions = function () {
            configurationMediator.loadUiFormTemplateActions('com.firstbest.underwriting.form.ui.UIFormTemplate:' + this.uiFormTemplateId).then(function (actions) {
                var allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: this.context.model.contextType
                });

                this.processActions(allActions, /*enableSaveAndDiscard*/false);
            }.bind(this));
        };

        this.loadFormTemplate = function () {
            configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (formTemplateConfig) {
                this.formTemplateConfig = formTemplateConfig;
                this.formTemplate = formTemplateConfig.formTemplate;
                this.formTemplateUniqueName = formTemplateConfig.formTemplate.uniqueName;
                this.formTemplateId = formTemplateConfig.formTemplate.id;
                this.hasEffectiveDate = this.formTemplate.effectiveDateRangeBegin && this.formTemplate.effectiveDateRangeEnd;

                this.formTemplateTypeLabel = _.get(translations, 'formTemplateBrowser.type.' + this.formTemplate.type);
                this.formTemplateStatus = _.get(translations, 'formEditorHeader.templateStatus.' + this.formTemplate.status);
                this.invalidFormTemplate = !_.isNil(this.formTemplate.valid) && !this.formTemplate.valid;
            }.bind(this));
        };

        this.processActions = function (actions, enableSaveAndDiscard) {
            this.actions = actions;
            this.actionSubTexts = {};

            _.each(this.actions, function (subAction) {
                _.each(subAction.actions, function (action) {
                    if (action.name === uIFormTemplateAction.SAVE || action.name === uIFormTemplateAction.DISCARD) {
                        action.enabled = enableSaveAndDiscard;
                    }

                    if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES || action.name === uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES) {
                        action.enabled = !enableSaveAndDiscard;
                        if(!action.enabled){
                            action.notes = _.get(translations, 'formEditorHeader.saveOrDiscardChangesBeforePublishing');
                        }
                    }

                    if (action.name === uIFormTemplateAction.SAVE && action.enabled) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(translations, 'formEditorHeader.unsavedChanges')
                        };
                    }
                }.bind(this));
            }.bind(this));

            this.actionsTimeLastModified = new Date().getTime();
        };

        this.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case uIFormTemplateAction.SAVE:
                        configurationActionsUtil.saveUiFormTemplate(this.uiFormTemplateId, false);
                        break;

                    case uIFormTemplateAction.SAVE_AS_NEW_VERSION:
                        configurationActionsUtil.saveUiFormTemplate(this.uiFormTemplateId, true);
                        break;

                    case uIFormTemplateAction.SHOW_FORM_REFERENCES:
                        configurationActionsUtil.showFormReferences('formReferences', this.uiFormTemplateId, this.formTemplateUniqueName);
                        break;

                    case uIFormTemplateAction.PUBLISH_FORM_TEMPLATES:
                        configurationActionsUtil.publishFormTemplates('formEditor.createFormTemplateSet.loadingBar', [this.formTemplate]);
                        break;

                    case uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES:
                        configurationActionsUtil.createTestFormTemplateSet();
                        break;

                    case uIFormTemplateAction.RELOAD_FORM_RULES:
                        configurationActionsUtil.reloadFormRules();
                        break;

                    case uIFormTemplateAction.RELOAD_FIELD_RULES:
                        configurationActionsUtil.reloadFieldRules();
                        break;

                    case uIFormTemplateAction.FORM_TEMPLATE_SETTINGS:
                        configurationActionsUtil.showFormTemplateSettings(this.uiFormTemplateId);
                        break;

                    case uIFormTemplateAction.DELETE:
                        configurationActionsUtil.deleteFormTemplate(this.uiFormTemplateId, this.formTemplateUniqueName, _.get(translations, 'formEditor'), 'formEditor.deleteFormTemplate.loadingBar');
                        break;

                    case uIFormTemplateAction.MARK_IN_PRODUCTION:
                        configurationActionsUtil.markFormTemplateInProduction(this.uiFormTemplateId, 'formEditor.markFormTemplateInProduction', _.get(translations, 'formEditor'));
                        break;

                    case uIFormTemplateAction.EXPORT:
                        configurationActionsUtil.exportFormTemplate(this.formTemplateId, 'formEditor.exportFormTemplate.loadingBar');
                        break;

                    case uIFormTemplateAction.DISCARD:
                        modalUtil.showConfirmationModal(null, null, null, 'formEditor.discard', null, true, function () {
                            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'formEditor.discard.success'));
                            $state.reload();
                        });
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.$on(formViewerConstant.event.FORM_TEMPLATE_INVALIDATED, function () {
            this.invalidFormTemplate = true;
        }.bind(this));

        $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, function (event, uiFormTemplate) {
            if (!_.isNil(uiFormTemplate)) {
                this.invalidFormTemplate = !uiFormTemplate.formTemplate.valid;
            }
            this.enableSaveAndDiscard = true;
            this.processActions(this.actions, this.enableSaveAndDiscard);
        }.bind(this));

        $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function (event, uiFormTemplate) {
            if (!_.isNil(uiFormTemplate)) {
                this.invalidFormTemplate = !uiFormTemplate.formTemplate.valid;
            }
            this.enableSaveAndDiscard = false;
            this.processActions(this.actions, this.enableSaveAndDiscard);
        }.bind(this));

        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            var isCurrentStateFormEditor = _.startsWith(fromState.name, 'configuration.formEditor'),
                isTargetSameAsCurrent = toState.name === fromState.name,
                formStructure,
                uiFormTemplate;
            if (toState.name === 'login') {
                return;
            }
            if (this.enableSaveAndDiscard && isCurrentStateFormEditor && !isTargetSameAsCurrent) {
                event.preventDefault();
                formStructure = formViewerModel.getFormStructure(this.uiFormTemplateId);
                if (formStructure) {
                    configurationActionsUtil.populateUiFormTemplateModel(this.uiFormTemplateId);
                    uiFormTemplate = formStructure.uiFormTemplate;
                } else {
                    uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
                }
                loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
                if (_.isNil(uiFormTemplate.id)) {
                    configurationMediator.createFormTemplate(uiFormTemplate).then(function (uiFormTemplate) {
                        loadingBarHandler.hideLoadingBar();
                        configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
                            this.enableSaveAndDiscard = false;
                            this.processActions(this.actions, this.enableSaveAndDiscard);
                            $state.go(toState, toParams);
                        }.bind(this));
                    }.bind(this));
                } else {
                    configurationMediator.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then(function (uiFormTemplate) {
                        loadingBarHandler.hideLoadingBar();
                        configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
                            this.enableSaveAndDiscard = false;
                            this.processActions(this.actions, this.enableSaveAndDiscard);
                            $state.go(toState, toParams);
                        }.bind(this));
                    }.bind(this));
                }
            }
        }.bind(this));

        this.loadActions();
        this.loadFormTemplate();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('formEditorHeaderController', FormEditorHeaderController);
